export default __webpack_public_path__ + "static/media/store-for-android.cde02f5e.svg";